import type { IconSvgObject } from './types';

const Grid3X3Icon: IconSvgObject = [
  ["path", { d: "M18.9961 3H4.99609C3.89152 3 2.99609 3.89543 2.99609 5V19C2.99609 20.1046 3.89152 21 4.99609 21H18.9961C20.1007 21 20.9961 20.1046 20.9961 19V5C20.9961 3.89543 20.1007 3 18.9961 3Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M8.99609 3V21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M14.9961 3V21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M21.002 15H3.00195", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M21.002 9H3.00195", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "4" }]
];

export default Grid3X3Icon;
